/* eslint-disable @typescript-eslint/indent */
/* eslint-disable indent */
import React, { useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { isEmpty, isNumber } from 'lodash';
import { init } from 'echarts';

import Color from '@tool/color';
import moDemandPdf from '../store';
import moIndex from '../../store';

interface IProps {}
interface IState {}
let chart: any = null;

const IndustryTrend = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const industryRef = useRef<any>(null);
  const { isMock } = moIndex;
  const { trendQuarter } = moDemandPdf;

  const getData = useMemo(() => {
    const xData: any = [];
    const num: any = [];
    const salary: any = [];
    if (!isEmpty(trendQuarter)) {
      trendQuarter.forEach((res: any) => {
        xData.push(res.time_str);
        num.push(res.amount);
        salary.push(res.salary);
      });
    }
    return { xData, num, salary };
  }, [trendQuarter]);

  const colorList = [Color.primary, Color.secondary];
  const render = () => {
    if (chart) chart.dispose();
    chart = init(industryRef.current);
    const option = {
      color: colorList,
      legend: {
        data: ['招聘量', '招聘薪酬'],
        bottom: 10,
        icon: 'roundRect',
        itemWidth: 8,
        itemHeight: 8,
        textStyle: {
          color: Color.c87,
          fontSize: 12,
        },
      },
      grid: {
        left: 5,
        right: 5,
        bottom: 40,
        top: 10,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: getData.xData,
        axisTick: { show: false },
        axisLine: {
          lineStyle: { color: Color.ccc },
        },
        axisLabel: {
          color: Color.blackColor(0.85),
          fontFamily: 'Roboto',
          fontSize: 9,
        },
      },
      yAxis: [
        {
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: { color: Color.ccc },
          },
          axisTick: { show: false },
          splitNumber: 4,
          axisLabel: {
            show: true,
            fontSize: 12,
            color: Color.blackColor(0.5),
            fontFamily: 'Roboto',
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: Color.blackColor(0.08),
              width: 1,
              type: 'dashed',
            },
          },
        },
        {
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: { color: Color.ccc },
          },
          splitNumber: 4,
          axisTick: { show: false },
          axisLabel: {
            formatter: (val: number) => {
              if (val === 0) return 0;
              return `${Number(val).toLocaleString()}`;
            },
            show: true,
            fontSize: 12,
            color: Color.blackColor(0.5),
            fontFamily: 'Roboto',
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: Color.blackColor(0.08),
              width: 1,
              type: 'dashed',
            },
          },
        },
      ],
      series: [
        {
          name: '招聘量',
          type: 'line',
          data: getData.num,
        },
        {
          name: '招聘薪酬',
          type: 'line',
          data: getData.salary,
          yAxisIndex: 1,
        },
      ],
    };
    chart.setOption(option, true);
  };

  useEffect(() => {
    render();
    window.addEventListener('resize', render);
    return () => {
      window.removeEventListener('resize', render);
    };
  }, [trendQuarter]);

  return (
    <section
      className="industry-trend-warp"
      ref={industryRef}
      style={{
        backgroundImage: isMock ?
          'url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)' :
          '',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
      }}/>
  );
};

export default observer(IndustryTrend);
